import { compose, flattenProp, lifecycle, withStateHandlers } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { addProps, addIntlProps } from 'utils/recompose';
import messages from './messages';
import {
  model,
  currentSelectedQuantity,
  modelRemainingQuota,
  modelSubmittedTotalWorkingStateCalculated,
  inCartQuantity,
} from 'reducers/models/selectors';
import combineSelectors from 'utils/combineSelectors';
import { setSelectedOptions } from 'reducers/search/actions';
import styles from './styles.module.scss';

export const initialState = {
  menuOpen: false,
};

export function componentDidMount() {
  window.addEventListener('scroll', this.props.searchMenuVisibility);
}

export function componentWillUnmount() {
  window.removeEventListener('scroll', this.props.searchMenuVisibility);
}

export const searchMenuVisibility = () => isOpen => {
  if (typeof isOpen === 'boolean') {
    return { menuOpen: isOpen };
  } else {
    return { menuOpen: false };
  }
};

export const openDropdown = () => () => {
  return { menuOpen: true };
};

// TODO: Once IPA data inconsistency is resolved, then we can use remainingQuota
// Until then, we calculate remainingQuota
export const remainingQuota = ({
  quota,
  modelSubmittedTotalWorkingStateCalculated,
  inCartQuantity,
}) => {
  let calculatedRemaining = quota - modelSubmittedTotalWorkingStateCalculated - inCartQuantity;
  return calculatedRemaining >= 0 ? calculatedRemaining : 0;
}

export const tabStyle = ({ inReviewView }) =>
  inReviewView
    ? {
        reviewTabStyle: styles.tabButtonActive,
        submittedTabStyle: styles.tabButton,
      }
    : {
        reviewTabStyle: styles.tabButton,
        submittedTabStyle: styles.tabButtonActive,
      };

const mapStateToProps = combineSelectors({
  model,
  currentSelectedQuantity,
  modelRemainingQuota,
  modelSubmittedTotalWorkingStateCalculated,
  inCartQuantity,
});

export default compose(
  connect(
    mapStateToProps,
    { setSelectedOptions },
  ),
  flattenProp('model'),
  injectIntl,
  withStateHandlers(initialState, {
    searchMenuVisibility,
    openDropdown,
  }),
  addIntlProps({
    messages,
    propNames: ['reviewLabel', 'submittedLabel'],
  }),
  addProps({ tabStyle, remainingQuota }),
  lifecycle({ componentDidMount, componentWillUnmount }),
);
